// import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Logo from '../assets/images/Logo.svg';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Plot from 'react-plotly.js';
import MoleculeViewer from '../components/MoleculeViewer';
import CH3Fdata from '../assets/data/CH3F.json';
import F2data from '../assets/data/F2.json';
import LiHdata from '../assets/data/LiH.json';



function Molecules(props) {

  const [userValue, userInputValue] = useRadioButtons("user");

  function useRadioButtons(name) {
    const [value, setState] = useState(null);
  
    const handleChange = e => {
      setState(e.target.value);
    };
  
    const inputProps = {
      name,
      type: "radio",
      onChange: handleChange
    };
    console.log("USER VALUE")
    console.log(value)
    return [value, inputProps];
  }


  // Set all molecules and parameters
  const molecules = ['CH3F', 'F2', 'LiH'];
  // select molecule from molecules list
  const [selectedMolecule, setSelectedMolecule] = useState('CH3F');
  // set active space
  const [activeSpace, setActiveSpace] = useState();
  // set all molecule parameters for graph
  const [selectedMolParams, setSelectedMolParams] = useState({
    transformation: '',
    optimizer: '',
    ansatzName: '',
    ansatzDepth: '',
    basis: '',
    quantumBackend: '',
    bondName: '',
  });
  
  var CH3F = {
    "bondName": "C-F",
    "basis": "sto-3g",
    "transformation": "Bravyi-Kitaev",
    "activeSpaceMethod": "frozen core and NOONs",
    "optimizer": "CG",
    "ansatzName": "Adapt-UCCSD",
    "ansatzDepth": "0.01",
    "quantumBackend": "QULACS"
  };

  var F2 = {
    "bondName": "F-F",
    "basis": "sto-3g",
    "transformation": "Jordan-Wigner",
    "activeSpaceMethod": "frozen core",
    "optimizer": "BFGS",
    "ansatzName": "UCCSD",
    "ansatzDepth": "1",
    "quantumBackend": "QULACS"
  };

  var LiH = {
    "bondName": "Li-H",
    "basis": "sto-3g",
    "transformation": "Jordan-Wigner",
    "activeSpaceMethod": "frozen core",
    "optimizer": "BFGS",
    "ansatzName": "UCCSD",
    "ansatzDepth": "1",
    "quantumBackend": "QULACS"
  };

  var molecules_info = {
    "LiH": LiH,
    "CH3F": CH3F,
    "F2": F2,
  }

  var molecules_data = {
    "LiH": LiHdata,
    "CH3F": CH3Fdata,
    "F2": F2data,
  }

  const handleChangeMolecule = (e) => {
    // Set selected molecule
    setSelectedMolecule(e.target.value);
    // To hide molecule viewer, table and graph
    setLoadGraph(false);
  };

  const [loadGraph, setLoadGraph] = useState(false);

const showSimulationParameters = false;
  // selectedMolParams.bondName !== '' && selectedMolecule !== '';
// console.log(showAllParameters)
const allSetParameters =
  selectedMolParams.bondName !== '' &&
  selectedMolParams.basis !== '' &&
  selectedMolParams.transformation !== '' &&
  selectedMolParams.optimizer !== '' &&
  selectedMolParams.ansatzName !== '' &&
  selectedMolParams.ansatzDepth !== '' &&
  selectedMolParams.quantumBackend !== '' &&
  selectedMolecule !== '' &&
  activeSpace !== 'None';

  useEffect(() => {
      setSelectedMolParams({
        // ...selectedMolParams,
        bondName: molecules_info[selectedMolecule].bondName,
        basis: molecules_info[selectedMolecule].basis,
        transformation: molecules_info[selectedMolecule].transformation,
        optimizer: molecules_info[selectedMolecule].optimizer,
        ansatzName: molecules_info[selectedMolecule].ansatzName,
        ansatzDepth: molecules_info[selectedMolecule].ansatzDepth,
        quantumBackend: molecules_info[selectedMolecule].quantumBackend,
      });
  }, [selectedMolecule]);
  // Leave just selectedMolecule to watch for changes

  // console.log(newBondName);
  const handleChangeParameters = (e) => {
    const { name, value } = e.target;
    setSelectedMolParams({
      ...selectedMolParams,
      [name]: value,
    });
  };

  // const for table data
  const [tableData, setTableData] = useState();
  //const [displayMolecule, setDisplayMolecule] = useState();
  //console.log(tableData, 'tabledata');

  // Button click to fetch data from API and receive new data to show Graph
  const handleClick = () => {
    const getParams = async () => {
      setResult(molecules_data[selectedMolecule].data);
      setLoadGraph(true);
    };
    getParams();
  };

  // -------------------- set Graph values from API ------------------------
  const [result, setResult] = useState(CH3Fdata.data);
  //console.log(result, 'result');
  useEffect(() => {
    if (result) {
      setTableData(() => {
        let numberOfQubits = [
          ...new Set(result.n_qubits.split(',').map((x) => x)),
        ];
        let numberOfGates = [
          ...new Set(result.gate_total.split(',').map((x) => x)),
        ];
        let numberOfParams = [
          ...new Set(result.n_params.split(',').map((x) => x)),
        ];
        let numberOfIterations = [
          ...new Set(result.n_iterations.split(',').map((x) => x)),
        ];
        let n_qubits_val = '';
        let n_gates_val = '';
        let n_params_val = '';
        let n_iters_val = '';

        if (numberOfQubits.length === 1) {
          n_qubits_val = numberOfQubits[0];
        } else {
          n_qubits_val =
            Math.min.apply(this, [...numberOfQubits]) +
            '-' +
            Math.max.apply(this, [...numberOfQubits]);
        }

        if (numberOfGates.length === 1) {
          n_gates_val = numberOfGates[0];
        } else {
          n_gates_val =
            Math.min.apply(this, [...numberOfGates]) +
            '-' +
            Math.max.apply(this, [...numberOfGates]);
        }

        if (numberOfParams.length === 1) {
          n_params_val = numberOfParams[0];
        } else {
          n_params_val =
            Math.min.apply(this, [...numberOfParams]) +
            '-' +
            Math.max.apply(this, [...numberOfParams]);
        }

        if (numberOfIterations.length === 1) {
          n_iters_val = numberOfIterations[0];
        } else {
          n_iters_val =
            Math.min.apply(this, [...numberOfIterations]) +
            '-' +
            Math.max.apply(this, [...numberOfIterations]);
        }

        return {
          n_qubits_val,
          n_gates_val,
          n_params_val,
          n_iters_val,
        };
      });
    }
  }, [result, selectedMolecule]);

  const processData = (data, energies) => {
    var bondDistances = data['bond_distances'].split(',');

    const energiesList = energies.split(',');
    const data_dict = {};

    energiesList.forEach((element, index) => {
      data_dict[element] = bondDistances[index];
    });

    var keyValues = [];

    for (var key in data_dict) {
      keyValues.push([key, data_dict[key]]);
    }

    keyValues.sort(function compare(kv1, kv2) {
      return kv1[1] - kv2[1];
    });

    var energiesArr = keyValues.map(function (value, index) {
      return value[0];
    });
    var bondsArr = keyValues.map(function (value, index) {
      return value[1];
    });

    return [energiesArr, bondsArr];
  };

  return (
    <>
      <Row>
        <div className='molecule-selection pfas-container'>
            <>
              <Col md={4} lg={3}>
                <div className='molecules-sidebar'>
                  <div className='logo'>
                    <img src={Logo} alt='Quantum logo' />
                  </div>
                  <div className='parameters'>
                    <div className='parameters-heading'>
                      Simulation of molecule as a: 
                    </div>
                    <form>
                    <h5>
                    <div className="radio">
                        <label>
                          <input type="radio" defaultChecked={true} value="CXO" checked={userValue === "CXO"}  {...userInputValue}/>
                          &nbsp;CXO
                        </label>
                      <div className="radio">
                        <label>
                          <input type="radio" value="Chemist" checked={userValue === "Chemist"} {...userInputValue}/>
                          &nbsp;Chemist  
                        </label>
                      </div>
                      </div>
                      </h5>
                    </form>
                    <br/>
                    {/* ----------------------Show parameters after molecule and bond selection---------------------- */}

                    {userValue == "Chemist" ? (
                      
                      <>
                    <form className='molecule'>
                      <div className='custom-mol-select'>
                        <select onChange={handleChangeMolecule}>
                          {molecules.map((mol) => {
                            return (
                              <option key={mol} value={mol} name='molecule'>
                                {mol}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <br />
                    </form>
                        <div className='molecule-parameters'>
                        <div className='bond-selection'>
                      <div>
                        {/* <div>
                Transformations are used to map our Hamiltonian from fermionic
                creation and annihilation operators to spin operators, making it
                useful on a quantum circuit.
              </div> */}
                        <form>
                          <legend>Selected bond:</legend>
                              <label key={molecules_info[selectedMolecule]["bondName"]}>
                                <input
                                  type='radio'
                                  name='bondName'
                                  id={molecules_info[selectedMolecule]["bondName"]}
                                  value={molecules_info[selectedMolecule]["bondName"]}
                                  key={molecules_info[selectedMolecule]["bondName"]}
                                  defaultChecked
                                />
                                {molecules_info[selectedMolecule]["bondName"]}
                              </label>
                          <br />
                        </form>
                      </div>
                    </div>
                          <div className='headline'>Simulation parameters:</div>
                          {/* BASIS */}
                          {/* <div>
            The basis we choose is used to approximate atomic orbitals and
            describe our Fock state.
          </div> */}
                          <div>
                            <form>
                              <legend className='parameters-name'>
                                Basis set 
                                {' '}
                                {/* <span className='parameters-info'>
                <i></i>
              </span> */}
                              </legend>
                                  <label key={molecules_info[selectedMolecule]["basis"]}>
                                    <input
                                      type='radio'
                                      name='basis'
                                      id={molecules_info[selectedMolecule]["basis"]}
                                      value={molecules_info[selectedMolecule]["basis"]}
                                      key={molecules_info[selectedMolecule]["basis"]}
                                      checked={
                                        selectedMolParams.basis.length !== 0
                                      }
                                    />
                                    {molecules_info[selectedMolecule]["basis"]}
                                  </label>
                              <br />
                            </form>
                          </div>
                          {/* TRANSFORMATION */}
                          <div>
                            {/* <div>
                Transformations are used to map our Hamiltonian from fermionic
                creation and annihilation operators to spin operators, making it
                useful on a quantum circuit.
              </div> */}
                            <form>
                              <legend className='parameters-name'>
                                Qubit Transformation
                                {' '}

                              </legend>
                              {
                                  <label key={molecules_info[selectedMolecule]["transformation"]}>
                                    <input
                                      type='radio'
                                      name='transformation'
                                      id='trans'
                                      value={molecules_info[selectedMolecule]["transformation"]}
                                      key={molecules_info[selectedMolecule]["transformation"]}
                                      checked={
                                        selectedMolParams.transformation
                                          .length !== 0
                                      }
                                    />
                                    {molecules_info[selectedMolecule]["transformation"]}
                                  </label>
                                }
                              <br />
                            </form>
                          </div>

                          {/* ACTIVE SPACE APPROXIMATION */}
                          <div>
                            <form className='space'>
                              <label className='parameters-name'>
                                Active Space Approximation
                              </label>
                              <br />
                              <select>
                                {
                                    <option
                                      key={molecules_info[selectedMolecule]["activeSpaceMethod"]}
                                      value={molecules_info[selectedMolecule]["activeSpaceMethod"]}
                                      name='activeSpaceMethod'
                                    >
                                      {molecules_info[selectedMolecule]["activeSpaceMethod"]}
                                    </option>
                                  }
                              </select>
                            </form>
                          </div>
                          {/* ------------------------------------------------------------------------------------------------------------------- */}
                          <div className='vqe-parameters'>
                            <div className='vqe-parameters-heading'>
                              VQE Parameters
                            </div>

                            {/* ANSATZ NAME */}
                            <div>
                              {/* <div>
                Ansatze is our initial parameterized state for which we will be
                optimizing the parameters.
              </div> */}
                              <form>
                                <legend className='parameters-name'>
                                  Ansatz
                                  {' '}

                                  <span className='parameters-info'></span>
                                </legend>
                                {
                                    <label key={molecules_info[selectedMolecule]["ansatzName"]}>
                                      <input
                                        type='radio'
                                        name='ansatzName'
                                        id={molecules_info[selectedMolecule]["ansatzName"]}
                                        value={molecules_info[selectedMolecule]["ansatzName"]}
                                        key={molecules_info[selectedMolecule]["ansatzName"]}
                                        checked={
                                          selectedMolParams.ansatzName
                                            .length !== 0
                                        }
                                      />
                                      {molecules_info[selectedMolecule]["ansatzName"]}
                                    </label>
                                  }
                                <br />
                              </form>
                            </div>

                            {/* ANSATZ DEPTH */}
                            <div>
                              {/* <div>Ansatz depths describe how long or deep our circuit is.</div> */}
                              <form>
                                <legend className='parameters-name'>
                                  Ansatz Depth
                                  {' '}

                                </legend>
                                {
                                    <label key={molecules_info[selectedMolecule]["ansatzDepth"]}>
                                      <input
                                        type='radio'
                                        name='ansatzDepth'
                                        id={molecules_info[selectedMolecule]["ansatzDepth"]}
                                        value={molecules_info[selectedMolecule]["ansatzDepth"]}
                                        key={molecules_info[selectedMolecule]["ansatzDepth"]}
                                        checked={
                                          selectedMolParams.ansatzDepth
                                            .length !== 0
                                        }
                                      />
                                      {molecules_info[selectedMolecule]["ansatzDepth"]}
                                    </label>
                                  }
                                <br />
                              </form>
                            </div>

                            {/* OPTIMIZERS */}
                            <div>
                              {/* <div>
                Optimizers are used by classical hardware to find a better guess
                for our parameters.
              </div> */}
                              <form>
                                <legend className='parameters-name'>
                                  VQE Optimizer
                                  {' '}

                                </legend>
                                {
                                    <label key={molecules_info[selectedMolecule]["optimizer"]}>
                                      <input
                                        type='radio'
                                        name='optimizer'
                                        id={molecules_info[selectedMolecule]["optimizer"]}
                                        value={molecules_info[selectedMolecule]["optimizer"]}
                                        onChange={handleChangeParameters}
                                        key={molecules_info[selectedMolecule]["optimizer"]}
                                        checked={
                                          selectedMolParams.optimizer.length !==
                                          0
                                        }
                                      />
                                      {molecules_info[selectedMolecule]["optimizer"]}
                                    </label>
                                  }
                                <br />
                              </form>
                            </div>
                          </div>

                          {/* QUANTUM BACKEND */}

                          <div>
                            <form>
                              <legend className='parameters-name'>
                                QUANTUM BACKEND{' '}

                              </legend>
                              {
                                  <label key={molecules_info[selectedMolecule]["quantumBackend"]}>
                                    <input
                                      type='radio'
                                      name='quantumBackend'
                                      id={molecules_info[selectedMolecule]["quantumBackend"]}
                                      value={molecules_info[selectedMolecule]["quantumBackend"]}
                                      key={molecules_info[selectedMolecule]["quantumBackend"]}
                                      checked={
                                        selectedMolParams.quantumBackend
                                          .length !== 0
                                      }
                                    />
                                    {molecules_info[selectedMolecule]["quantumBackend"]}
                                  </label>
                                }
                              <br />
                            </form>
                          </div>
                        </div>
                      </>
                    ) : userValue == "CXO" ? (
                      <>
                      <form className='molecule'>
                      <div className='custom-mol-select'>
                        <select onChange={handleChangeMolecule}>
                          {molecules.map((mol) => {
                            return (
                              <option key={mol} value={mol} name='molecule'>
                                {mol}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <br />
                    </form>

                      <div>
                      In order to design a functional catalsyt for PFAS, it's essential to calculate the energy as the bonded atoms dissociate (break apart). <br/>
                      <br/>
                      Here we demonstrate the calculated bond dissociation curve using multiple methods, including FCI (Full Configuration Energy) which is the gold standard against which other methods are compared. <br/>
                      <br/>
                      This calculation was obtained from a quantum simulator. We expect full PFAS molecules will be able to run accurately on quantum systems around the end of the decade.
                      <br/>
                      <br/>
                      </div>
                      </>
                    ) : ( <div/> )}
                        {allSetParameters ? (
                          <button
                            onClick={handleClick}
                            // Need what about diabled button style?
                            // className={`btn btn-primary ${
                            //   allSetParameters ? '' : 'disabled'
                            // }`}
                            className='pfas-btn-blue'
                          >
                            Show results
                          </button>
                        ) : ( 
                          ''
                        )}
                  </div>
                </div>
              </Col>
              {/* <MoleculeViewer molecule={selectedMolecule} /> */}
              <Col md={8} lg={9}>
                <div className='molecules-graph'>
                  <div>
                    <div className='navigation'>
                      <div className='nav'>
                        <Link to='/pfasproject' className='pfas-btn-white-back'>
                          <div className='nav-text-back'>Previous</div>
                        </Link>
                        <Link to='/'>
                          <div className='nav-home'></div>
                        </Link>
                        {/* <div className='nav-page-nr'>7/9</div> */}

                        <Link
                          to='/pfasarchitecture'
                          className='pfas-btn-white-next-architecture'
                        >
                          <div className='nav-text-next-dark'>Architecture</div>
                        </Link>
                      </div>
                    </div>

                    {loadGraph ? (
                      <>
                        <div className='molecules-data'>
                          <div className='molecule-view'>
                            <MoleculeViewer molecule={selectedMolecule} />
                          </div>
                          {tableData ? (
                            <div className='table'>
                              <div className='table-name'>Table of values</div>
                              <table>
                                <tr>
                                  <td className='td-bold'>Number of qubits</td>
                                  <td>{tableData.n_qubits_val}</td>
                                </tr>
                                <tr>
                                  <td className='td-bold'>Number of gates</td>
                                  <td>{tableData.n_gates_val}</td>
                                </tr>
                                <tr>
                                  <td className='td-bold'>
                                    Number of VQE parameters
                                    {userValue == "CXO" ? ( <font size="2" weight="200"><br/>(Model complexity)</font> ) : (<div></div> )}
                                  </td>
                                  <td>{tableData.n_params_val}</td>
                                </tr>
                                <tr>
                                  <td className='td-bold'>
                                    Number of VQE iterations
                                    {userValue == "CXO" ? ( <font size="2" weight="200"><br/>(Classical optimizations)</font> ) : (<div></div> )}
                                  </td>
                                  <td>{tableData.n_iters_val}</td>
                                </tr>
                              </table>
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                        <div className='graph'>
                          <Plot
                            data={[
                              {
                                x: processData(
                                  result,
                                  result['converged_energies']
                                )[1],
                                y: processData(
                                  result,
                                  result['converged_energies']
                                )[0],
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: { color: '#cc13cc' },
                                name: 'Converged Energy',
                              },
                              {
                                x: processData(
                                  result,
                                  result['hf_energies']
                                )[1],
                                y: processData(
                                  result,
                                  result['hf_energies']
                                )[0],
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: { color: '#DB3042' },
                                name: 'HF Energy',
                              },
                              {
                                x: processData(
                                  result,
                                  result['fci_energies']
                                )[1],
                                y: processData(
                                  result,
                                  result['fci_energies']
                                )[0],
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: { color: '#3C69E7' },
                                name: 'FCI Energy',
                              },
                            ]}
                            layout={{
                              width: 700,
                              height: 480,
                              legend: { x: 0.6, y: 1 },
                              title: {
                                text: 'Bond Dissociation Curve',
                                font: {
                                  size: 25,
                                  weight: 700,
                                },
                              },
                              paper_bgcolor: 'rgba(0,0,0,0)',
                              plot_bgcolor: 'rgba:(0,0,0,0)',
                              displayModeBar: false,
                              font: { color: '#141515' },
                              xaxis: {
                                title: {
                                  text: 'Bond distance (Ångstrom)',
                                  font: {
                                    size: 18,
                                    color: '#141515',
                                  },
                                },
                              },
                              yaxis: {
                                title: {
                                  text: 'Energy (Hartree)',
                                  font: {
                                    size: 18,
                                    color: '#141515',
                                  },
                                },
                              },
                            }}
                            // {responsive: true}
                          />
                        </div>
                      </>
                    ) : (
                      <div>
                        {/* PLease select values. Right side of page */}
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </>
        </div>
      </Row>
    </>
  );
}

export default Molecules;
